import config from '../config';
import { request } from '../utils/request';

const vendorDomain = `${config.host}${config.apiRouter.rioVendor}`;

const api = {
  // 创建供应商
  createVendor (data) {
    return request({
      method: 'POST',
      url: `${vendorDomain}/create?version=2018-12-18`,
      data,
    });
  },
  updateVendor (data) {
    return request({
      method: 'POST',
      url: `${vendorDomain}/update?version=2018-12-18`,
      data,
    });
  },
};
export default api;
